export default "__VITE_ASSET__CHQ9Trjw__"